<template>
  <!-- style を class 化してもスタイルを上書きできないので直接指定 -->
  <v-btn large rounded :style="btnStyle" @click="click">{{ text }}</v-btn>
</template>

<script>
export default {
  props: {
    text: String,
    click: Function,
    bgColor: {
      type: String,
      default: "#798191",
    },
    textColor: {
      type: String,
      default: "#FFFFFF",
    },
  },
  data: () => ({
    btnStyle: "",
  }),
  created() {
    this.btnStyle = `background:${this.bgColor}; color:${this.textColor};`;
    console.log(this.btnStyle);
  },
  async mounted() {},
  computed: {},
  methods: {},
};
</script>
